import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const formItems = [
        {
            label: "父级机构",
            span: 24,
            placeholder: '请选择父级机构',
            type: 'buttonInput',
            model: "parentName",
            disabled: true,
            click: function () {
                that.dialogVisible = true
            }
        },
        {
            label: "机构类别",
            span: 24,
            placeholder: '请选择类别',
            type: "select",
            model: "organType",
            options: dic._ORGAN_TYPE
        },
        {
            label: "机构名称",
            span: 24,
            placeholder: '请输入机构名称',
            model: "name"
        },
        {
            label: "描述信息",
            span: 24,
            placeholder: '请输入描述信息',
            type: "textarea",
            rows: 10,
            model: "description"
        },
        {
            label: "显示顺序",
            span: 24,
            type: 'number',
            placeholder: '请输入机构显示顺序',
            model: "sort"
        },
    ]
    const formRules = {
        organType: [{
            required: true,
            message: "请选择机构类别",
            trigger: "blur"
        }],
        name: [{
            required: true,
            message: "请输入机构名称",
            trigger: "blur"
        }],
    }

    return {
        formItems,
        formRules
    }
}
